import PropTypes from 'prop-types';

export const linkShape = {
    title: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
}